import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 26447 26580"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528324040544">
        <path
          d="M21377 22081H5074c-105 0-198-66-234-161-36-99-9-207 69-276 710-615 1118-1493 1118-2407s-408-1792-1118-2406c-78-69-105-177-69-276s129-162 234-162h16303c105 0 198 63 234 162 36 96 9 207-69 276-711 614-1118 1492-1118 2406s407 1792 1118 2407c78 69 105 177 69 276-36 95-129 161-234 161zm-15713-497h15120c-552-660-861-1490-861-2347s309-1684 861-2346H5664c551 662 860 1489 860 2346s-309 1685-860 2347z"
          className="fil0"
        />
        <path
          d="M18323 19486H8127c-137 0-248-111-248-249s111-249 248-249h10196c138 0 249 111 249 249s-111 249-249 249zM18323 16891H8127c-137 0-248-111-248-249v-1013c0-138 111-249 248-249h10196c138 0 249 111 249 249v1013c0 138-111 249-249 249zm-9947-498h9698v-515H8376v515z"
          className="fil0"
        />
        <path
          d="M21377 15878H5074c-105 0-198-63-234-162-36-96-9-207 69-276 710-614 1118-1492 1118-2406 0-915-408-1792-1118-2407-78-69-105-177-69-276s129-162 234-162h16303c105 0 198 63 234 162 36 96 9 207-69 276-711 615-1118 1492-1118 2407 0 914 407 1792 1118 2406 78 69 105 177 69 276-36 96-129 162-234 162zm-15713-498h15120c-552-662-861-1489-861-2346s309-1688 861-2347H5664c551 659 860 1490 860 2347s-309 1684-860 2346z"
          className="fil0"
        />
        <path
          d="M18323 13282H8127c-137 0-248-111-248-248 0-138 111-249 248-249h10196c138 0 249 111 249 249 0 137-111 248-249 248zM18323 10687H8127c-137 0-248-111-248-249V9425c0-137 111-248 248-248h10196c138 0 249 111 249 248v1013c0 138-111 249-249 249zm-9947-498h9698v-515H8376v515z"
          className="fil0"
        />
        <path
          d="M21377 9674H5074c-105 0-198-66-234-162s-9-206 69-276c710-614 1118-1492 1118-2406s-408-1792-1118-2406c-78-70-105-178-69-276 36-99 129-162 234-162h16303c105 0 198 66 234 162s9 206-69 276c-711 614-1118 1492-1118 2406s407 1792 1118 2406c78 70 105 177 69 276-36 96-129 162-234 162zM5664 9177h15120c-552-660-861-1490-861-2347s309-1687 861-2347H5664c551 660 860 1490 860 2347s-309 1687-860 2347z"
          className="fil0"
        />
        <path
          d="M18323 7079H8127c-137 0-248-111-248-249s111-249 248-249h10196c138 0 249 111 249 249s-111 249-249 249zM18323 4483H8127c-137 0-248-111-248-248V3222c0-138 111-249 248-249h10196c138 0 249 111 249 249v1013c0 137-111 248-249 248zm-9947-497h9698v-515H8376v515z"
          className="fil0"
        />
        <path
          d="M22801 26580c-138 0-249-111-249-249V3471H3899v22860c0 138-111 249-249 249s-249-111-249-249V3222c0-138 111-249 249-249h19151c137 0 248 111 248 249v23109c0 138-111 249-248 249z"
          className="fil0"
        />
        <path
          d="M24371 24509c-138 0-249-111-249-249V3473H2326v20787c0 138-111 249-249 249s-249-111-249-249V3225c0-138 111-249 249-249h22291c138 0 249 111 249 249v21035c3 138-108 249-246 249z"
          className="fil0"
        />
        <path
          d="M26199 3471H249c-138 0-249-111-249-249V249C0 111 111 0 249 0h25950c138 0 248 111 248 249v2973c0 138-110 249-248 249zM498 2973h25452V498H498v2475zM18554 23562c-138 0-249-111-249-249v-1483c0-138 111-249 249-249s249 111 249 249v1483c0 138-111 249-249 249z"
          className="fil0"
        />
        <path
          d="M19435 25806h-1765c-81 0-159-41-207-108-45-68-57-155-27-230l881-2242c75-189 386-189 465 0l881 2242c30 78 21 164-27 230-42 67-120 108-201 108zm-1400-497h1034l-515-1313-519 1313zM7897 23562c-138 0-249-111-249-249v-1483c0-138 111-249 249-249s248 111 248 249v1483c0 138-110 249-248 249z"
          className="fil0"
        />
        <path
          d="M8778 25806H7013c-81 0-159-41-207-108-45-68-57-155-27-230l881-2242c75-189 390-189 465 0l881 2242c29 78 20 164-27 230-42 67-117 108-201 108zm-1397-497h1034l-515-1313-519 1313z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
